



























import {
  defineComponent,
  PropType,
  getCurrentInstance
} from "@vue/composition-api";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccBody from "@/components/Atoms/OccBody/index.vue";
import { Location } from "vue-router";
import { sendGaEvent } from "@/helpers/ga-helper";

export type BreadcrumbRoute = {
  label: string;
  to?: Location;
  disabled?: boolean;
};

export default defineComponent({
  name: "OccBreadcrumbs",
  components: {
    OccHeading,
    OccBody
  },
  props: {
    routes: {
      type: Array as PropType<BreadcrumbRoute[]>,
      required: true
    }
  },
  setup() {
    const instance = getCurrentInstance();
    const handleClick = (gaEventCategory: string) => {
      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventCategory: `パンくず_${gaEventCategory}`
        });
      }
    };
    return { handleClick };
  }
});
